import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import hooks from 'hooks';
import { showError } from './handleError';

const { Notification } = hooks;

export const notifySuccess = (
  message = '',
  title = '',
  callback = () => {},
  timeout = TIME_OUT_CLOSE_TOAST,
) => {
  Notification('success', message, title, timeout, callback);
};

export const notifyError = (message = '') => {
  showError(message);
};

export const notifyInfo = (
  message = '',
  title = '',
  callback = () => {},
  timeout = TIME_OUT_CLOSE_TOAST,
) => {
  Notification('info', message, title, timeout, callback);
};
